module.exports = __webpack_public_path__ + "img/ab.dc676c22.jpeg";